import NewTab from "graphics/icons/General/NewTab";
import React from "react";

const DeviceIssueTip = () => {
  return (
    <>
      <span
        style={{ opacity: "0.6", fontStyle: "italic", verticalAlign: "sub" }}
      >
        Having issues connecting your device?
      </span>
      <a
        href={"https://efficespace.com/devices-help/"}
        target={"_blank"}
        rel={"noreferrer"}
        className="suggest-fix-device discreet"
      >
        Find Out Why &nbsp;
        <NewTab />
      </a>
    </>
  );
};

export default DeviceIssueTip;
